<template>
    <div class="notification-snackbars-container">
        <transition-group name="notification-slide" tag="div">
            <v-card
                v-if="notificationSnackbars.length > 1"
                key="dismiss-all"
                class="notification-dismiss-all-card mb-2 elevation-4"
                dark
                width="350"
                @click="dismissAll">
                <div class="d-flex align-center justify-center pa-1">
                    <v-icon x-small class="mr-1">mdi-close-circle-outline</v-icon>
                    <span class="fs11i">Chiudi tutte ({{ notificationSnackbars.length }})</span>
                </div>
            </v-card>

            <v-card
                v-for="notification in notificationSnackbars"
                :key="notification.id"
                class="notification-snackbar-card mb-2 elevation-6"
                dark
                width="350"
                @click="handleClick(notification)"
                style="cursor: pointer">
                <div class="d-flex align-center pa-3 pb-2">
                    <v-avatar
                        v-if="$store.getters.avatars[notification.user_id]"
                        class="custom-avatar mr-3"
                        :size="40"
                        :style="{'background-image': 'url(' + $store.getters.avatars[notification.user_id] + ')'}">
                    </v-avatar>
                    <v-avatar
                        v-else
                        :class="$eventBusUtility.bgColor(notification.user_id)"
                        :size="40"
                        class="mr-3">
                        <span class="white--text fs14" v-if="notification.creator">{{ notification.creator.charAt(0) }}</span>
                        <v-icon v-else color="white" small>mdi-bell</v-icon>
                    </v-avatar>

                    <div class="flex-grow-1" style="min-width: 0">
                        <div class="fw500 fs13i text-truncate">{{ notification.title }}</div>
                        <div class="fs12i grey--text text--lighten-1 text-truncate" v-if="notification.subtitle">{{ notification.subtitle }}</div>
                        <div class="fs11i grey--text text--lighten-2 text-truncate" v-if="notification.text">{{ notification.text }}</div>
                    </div>

                    <v-btn icon small class="ml-2" @click.stop="dismiss(notification.id)">
                        <v-icon small>mdi-close</v-icon>
                    </v-btn>
                </div>
                <v-progress-linear
                    :value="getProgress(notification.id)"
                    color="primary"
                    height="3"
                    class="notification-progress">
                </v-progress-linear>
            </v-card>
        </transition-group>
    </div>
</template>

<script>
export default {
    name: 'NotificationSnackbars',

    data() {
        return {
            timers: {},
            progressIntervals: {},
            progressValues: {}
        }
    },

    computed: {
        notificationSnackbars() {
            return this.$store.getters.notificationSnackbars
        },
        snackbarEnabled() {
            const val = this.$store.getters.getSettingByModel('viewing', 'notification_snackbar_enabled')
            if (val === undefined) return false
            return !!val
        },
        snackbarDuration() {
            const val = this.$store.getters.getSettingByModel('viewing', 'notification_snackbar_duration')
            return (val && val > 0) ? val * 1000 : 30000
        },
        autoReadEnabled() {
            return !this.$store.getters.getSettingByModel('viewing', 'notification_disable_auto_read')
        }
    },

    watch: {
        notificationSnackbars: {
            handler(newVal) {
                if (!newVal) return
                newVal.forEach(n => {
                    if (!this.timers[n.id]) {
                        if (!this.snackbarEnabled) {
                            this.$store.commit('REMOVE_NOTIFICATION_SNACKBAR', n.id)
                            return
                        }

                        const duration = this.snackbarDuration
                        this.$set(this.progressValues, n.id, 100)

                        const step = 100 / (duration / 100)
                        this.progressIntervals[n.id] = setInterval(() => {
                            this.progressValues[n.id] -= step
                            if (this.progressValues[n.id] <= 0) {
                                this.progressValues[n.id] = 0
                            }
                        }, 100)

                        this.timers[n.id] = setTimeout(() => {
                            this.dismiss(n.id)
                        }, duration)
                    }
                })
            },
            deep: true,
            immediate: true
        }
    },

    methods: {
        getProgress(id) {
            return this.progressValues[id] || 0
        },

        handleClick(notification) {
            if (this.autoReadEnabled) {
                this.$store.commit('REMOVE_NOTIFICATION', notification.id)
                this.$eventBusUtility.changeNotificationStatus([notification.id], 'read')
            }
            if (notification.modelDef === 'whatsappconversations') {
                this.$router.push({
                    path: '/whatsapp',
                    query: { conversation_id: notification.modelDefId }
                }).catch(() => {})
            } else if (notification.modelDef === 'event') {
                this.$router.push({
                    path: '/calendar',
                    query: { event_id: notification.modelDefId }
                }).catch(() => {})
            } else if (notification.modelDef === 'calendar') {
                this.$router.push({
                    path: '/calendar'
                }).catch(() => {})
            } else if (notification.modelDef === 'archives' || notification.type === 'archives') {
                this.$router.push({
                    path: '/profile/download/'
                }).catch(() => {})
            } else if (notification.type === 'google_account') {
                this.$router.push({
                    path: '/profile/calendars'
                }).catch(() => {})
            } else if (notification.modelDef && notification.modelDefId) {
                let routeName = notification.modelDef + '-show'
                try {
                    let resolved = this.$router.resolve({ name: routeName, params: { id: notification.modelDefId } })
                    if (resolved && resolved.route.name !== undefined) {
                        this.$router.push({ name: routeName, params: { id: notification.modelDefId } }).catch(() => {})
                    }
                } catch (e) {
                    // route non esistente
                }
            }
            this.dismiss(notification.id)
        },

        dismiss(id) {
            if (this.timers[id]) {
                clearTimeout(this.timers[id])
                delete this.timers[id]
            }
            if (this.progressIntervals[id]) {
                clearInterval(this.progressIntervals[id])
                delete this.progressIntervals[id]
            }
            this.$delete(this.progressValues, id)
            this.$store.commit('REMOVE_NOTIFICATION_SNACKBAR', id)
        },

        dismissAll() {
            const ids = this.notificationSnackbars.map(n => n.id)
            ids.forEach(id => this.dismiss(id))
        }
    },

    beforeDestroy() {
        Object.values(this.timers).forEach(t => clearTimeout(t))
        Object.values(this.progressIntervals).forEach(i => clearInterval(i))
    }
}
</script>

<style scoped>
.notification-snackbars-container {
    position: fixed;
    top: 64px;
    right: 16px;
    z-index: 210;
    max-width: 350px;
}

.notification-snackbar-card {
    background-color: #323232 !important;
    border-radius: 8px !important;
    overflow: hidden;
}

.notification-dismiss-all-card {
    background-color: #424242 !important;
    border-radius: 6px !important;
    cursor: pointer;
    opacity: 0.9;
}

.notification-dismiss-all-card:hover {
    opacity: 1;
    background-color: #505050 !important;
}

.notification-progress {
    margin: 0;
    border-radius: 0 0 8px 8px;
}

.notification-slide-enter-active,
.notification-slide-leave-active {
    transition: all 0.3s ease;
}

.notification-slide-enter,
.notification-slide-leave-to {
    opacity: 0;
    transform: translateX(50px);
}
</style>
